import Vue from 'vue'
import Vuex from 'vuex'
import API from '@/api'
import { getIsCollapse, setIsCollapse } from '@/utils/auth'

import getters from './getters'
import user from './modules/user'
import coupon from './modules/coupon.js'

Vue.use(Vuex)

const SET_IS_COLLAPSE = 'SET_IS_COLLAPSE'

export default new Vuex.Store({
  state: {
    isCollapse: getIsCollapse() || false, // 左侧菜单状态（展开/折叠）
    orderGetListParams: {
      pageNumber: 1,
      pageSize: 20
    }, // 订单列表参数存储
    goodsGetListParams: {
      pageNumber: 1,
      pageSize: 20
    }, // 品类列表参数存储
    stockGetListParams: {
      pageNumber: 1,
      pageSize: 20,
      active: 1
    }, // 库存列表参数存储
    userGetListParams: {
      pageNumber: 1,
      pageSize: 20
    },
    customizationGetListParams: {
      pageNumber: 1,
      pageSize: 20
    }, // 定制列表参数存储
    newFunctionGetListParams: {
      pageNumber: 1,
      pageSize: 20
    }, // 站内信列表参数存储
    promotionGetListParams: {
      pageNumber: 1,
      pageSize: 20
    }, // 运营活动列表参数存储
    platformList: []
  },
  mutations: {
    setState(state, object) {
      state[object.key] = object.value
    },
    [SET_IS_COLLAPSE](state, status) {
      state.isCollapse = status
    }
  },
  actions: {
    setIsCollapse({ commit }, status) {
      setIsCollapse(status)
      commit(SET_IS_COLLAPSE, status)
    },
    getPlatFormList({ commit }) {
      return new Promise((resolve) => {
        API.getPlatformSelect({ status: 0 }).then((res) => {
          commit('setState', { key: 'platformList', value: res.data })
          resolve()
        })
      })
    }
  },
  modules: {
    user,
    coupon
  },
  getters
})
